export default __webpack_public_path__ + "static/media/avalanche-logo.30dfa545.png";